module.exports = __webpack_public_path__ + "media/images/pricing-page-call-9903c2ec.png";